import type { ErrorComponentProps } from "@tanstack/react-router"
import { usePostHog } from "posthog-js/react"
import { useEffect } from "react"

export function ErrorFallback({ error, reset, info }: ErrorComponentProps) {
  const posthog = usePostHog()

  useEffect(() => {
    posthog.captureException(error, { info })
  }, [posthog, error, info])

  return (
    <div className="flex min-h-dvh items-center justify-center">
      <div className="space-y-4 px-4 text-center">
        <h1 className="font-mono text-6xl font-bold text-default">500</h1>
        <h2 className="text-2xl font-semibold text-default">Something went wrong</h2>
        <p className="max-w-md text-muted">
          An unexpected error occurred. Please try refreshing the page.
        </p>
        <div className="pt-4">
          <button
            onClick={reset}
            className="inline-block rounded bg-neutral-900 px-6 py-3 font-normal text-white transition-colors hover:bg-neutral-800 dark:bg-neutral-100 dark:text-neutral-900 hover:dark:bg-neutral-200"
          >
            Refresh
          </button>
        </div>
      </div>
    </div>
  )
}
